import { z } from 'zod';
export const partnerSourceSchema = z.enum({
    RecommendationProgram: `Recommendation Program`,
    Research: `Research`,
    InboundWebForm: `Inbound Web Form`,
    PartnerCockpitOnboarding: `Partner Cockpit Onboarding`,
    InboundCall: `Inbound Call`,
    InboundMail: `Inbound Mail`,
    FacebookCampaign: `Facebook Campaign`,
    LinkedInCampaign: `LinkedIn Campaign`,
    GoogleCampaign: `Google Campaign`,
    SearchEngine: `Search Engine`,
    Advertisement: `Advertisement`,
    EmployeeReferral: `Employee Referral`,
    ClientReferral: `Client Referral`,
    Cohaga: `Cohaga`,
    UBS: `UBS`,
    Startup: `Startup`,
});
export const PartnerSource = partnerSourceSchema.enum;
